import React, { useState } from 'react';
import { BreadcrumbProps } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import RouteMap, { RouteInfo } from '../../pages/daf/AppDAF/RouteMap';
import RouteMapFornecedor from '../../pages/fornecedor/AppFornecedor/RouteMapFornecedor';
import RouteMapSes from '../../pages/ses/AppSES/RouteMapSes';
import { formatBreadcrumbTitle } from '../../utils/functions';
import Ajuda from '../Ajuda';
import OffCanvas from '../OffCanvas';

const BreadcrumbContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  height: 100%;
  margin-left: 10px;

  .material-icons:hover {
    cursor: default;
    color: #0a58ca;
  }
`;

const StyledBreadcrumb = styled.div`
  display: flex;
  justify-content: space-between; /* Garante que os ícones fiquem nos cantos e o conteúdo no meio */
  align-items: center; /* Centraliza verticalmente o conteúdo */
  height: 100%; /* Garante que o Breadcrumb ocupe toda a altura */
  width: 100%;
  padding: 0 10px; /* Espaçamento horizontal para dar um respiro */

  .left-icon,
  .right-icon {
    color: #0a58ca;
  }

  .right-icon {
    padding: 10px;
    cursor: pointer;
  }
  .breadcrumb-content {
    flex-grow: 1; /* Faz o conteúdo ocupar todo o espaço disponível */
    text-align: left; /* Garante que o texto esteja alinhado à esquerda */
    padding: 0 10px; /* Adiciona espaçamento horizontal */
  }

  ol.breadcrumb {
    margin-bottom: 0;
  }
`;

type RouteMapType = typeof RouteMap;

const findRouteInfo = (path: string, routeMap: RouteMapType): RouteInfo => {
  const matchingRoute = Object.keys(routeMap).find((routePattern) => {
    const regexPattern = new RegExp(
      `^${routePattern.replace(/:\w+/g, '\\w+')}$`,
    );
    return regexPattern.test(path);
  });

  return matchingRoute ? routeMap[matchingRoute] : routeMap['/'];
};

interface BdcrumbProps extends BreadcrumbProps {
  tipoSubdominio?: 'daf' | 'secsaude' | 'fornecedor';
}

const Breadcrumbs: React.FC<BdcrumbProps> = ({
  tipoSubdominio = 'daf',
  ...props
}) => {
  // console.log('Renderizando Breadcrumbs com props:', props);
  const location = useLocation();
  let mapeadorDeRotas;
  switch (tipoSubdominio) {
    case 'secsaude':
      mapeadorDeRotas = RouteMapSes;
      break;
    case 'fornecedor':
      mapeadorDeRotas = RouteMapFornecedor;
      break;
    default:
      mapeadorDeRotas = RouteMap;
  }
  const routeInfo = findRouteInfo(location.pathname, mapeadorDeRotas);

  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const handleShowOffcanvas = () => {
    setShowOffcanvas(true);
  };

  const handleCloseOffcanvas = () => {
    setShowOffcanvas(false);
  };

  return (
    <>
      <BreadcrumbContainer>
        <StyledBreadcrumb>
          <span className="material-icons left-icon">{routeInfo.icon}</span>

          <span className="breadcrumb-content">
            {formatBreadcrumbTitle(routeInfo.title).before &&
              `${formatBreadcrumbTitle(routeInfo.title).before} / `}
            <b>{formatBreadcrumbTitle(routeInfo.title).highlightedSegment}</b>
            {formatBreadcrumbTitle(routeInfo.title).after &&
              ` / ${formatBreadcrumbTitle(routeInfo.title).after}`}
          </span>

          <span
            className="material-icons right-icon"
            onClick={handleShowOffcanvas}
            style={{ cursor: 'pointer' }}
          >
            help
          </span>
        </StyledBreadcrumb>
      </BreadcrumbContainer>

      <OffCanvas
        placement="end"
        name={routeInfo.module}
        show={showOffcanvas}
        onHide={handleCloseOffcanvas}
        style={{ width: '40%' }}
        botaoAbrir={false}
        mostrarBotaoCopiar={false}
      >
        {<Ajuda />}
      </OffCanvas>
    </>
  );
};

export default Breadcrumbs;
